import { useTheme } from "@mui/joy";
import { Grow, useMediaQuery, Zoom } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import { useNavigate } from "react-router-dom";
import DialogClose from "./dialogClose";

export default function SlidingDialog({
  children,
  onClose,
  open,
}: {
  children: React.ReactNode;
  onClose?: () => void;
  open: boolean;
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <DialogClose
      open={open}
      closeColor={"neutral"}
      TransitionComponent={Transition}
      fullScreen
      sx={{ margin: "12px" }}
      slotProps={{
        root: {
          style: { borderRadius: "8px", overflow: "hidden" },
        },
      }}
      onClose={() => (onClose ? onClose() : navigate(-1))}
    >
      {children}
    </DialogClose>
  );
}

export const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Grow ref={ref} {...props} />;
});
